const GET_CHILD_GALLERY_REQUEST = 'GET_CHILD_GALLERY_REQUEST';
const GET_CHILD_GALLERY_SUCCESS = 'GET_CHILD_GALLERY_SUCCESS';
const GET_CHILD_GALLERY_FAILURE = 'GET_CHILD_GALLERY_FAILURE';
const UPLOAD_PHOTOS_TO_CHILD_GALLERY_REQUEST = 'UPLOAD_PHOTOS_TO_CHILD_GALLERY_REQUEST';
const UPLOAD_PHOTOS_TO_CHILD_GALLERY_SUCCESS = 'UPLOAD_PHOTOS_TO_CHILD_GALLERY_SUCCESS';
const UPLOAD_PHOTOS_TO_CHILD_GALLERY_FAILURE = 'UPLOAD_PHOTOS_TO_CHILD_GALLERY_FAILURE';
const REMOVE_PHOTO_FROM_CHILD_GALLERY_REQUEST = 'REMOVE_PHOTO_FROM_CHILD_GALLERY_REQUEST';
const REMOVE_PHOTO_FROM_CHILD_GALLERY_SUCCESS = 'REMOVE_PHOTO_FROM_CHILD_GALLERY_SUCCESS';
const REMOVE_PHOTO_FROM_CHILD_GALLERY_FAILURE = 'REMOVE_PHOTO_FROM_CHILD_GALLERY_FAILURE';

export default {
  GET_CHILD_GALLERY_REQUEST,
  GET_CHILD_GALLERY_SUCCESS,
  GET_CHILD_GALLERY_FAILURE,
  UPLOAD_PHOTOS_TO_CHILD_GALLERY_REQUEST,
  UPLOAD_PHOTOS_TO_CHILD_GALLERY_SUCCESS,
  UPLOAD_PHOTOS_TO_CHILD_GALLERY_FAILURE,
  REMOVE_PHOTO_FROM_CHILD_GALLERY_REQUEST,
  REMOVE_PHOTO_FROM_CHILD_GALLERY_SUCCESS,
  REMOVE_PHOTO_FROM_CHILD_GALLERY_FAILURE
};
